'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$uibModal', 'MilestoneRestService',
                function($modal, MilestoneRestService) {
                    return {
                        select: select,
                        create: create,
                        edit: edit,
                        api: MilestoneRestService,
                    };

                    function select(milestone, filters, def) {
                        return $modal.open({
                            template: require('../view/milestone-modal-select.html'),
                            controller: 'MilestoneModalSelectController',
                            size: 'lg',
                            backdrop: false,
                            resolve: {
                                milestone: function() {
                                    return milestone;
                                },
                                milestoneFilters: function() {
                                    return filters != null ? filters : [];
                                },
                                def: () => {
                                    return {};
                                },
                            },
                        });
                    }

                    function create(def) {
                        return $modal.open({
                            template: require('../view/milestone-modal-create.html'),
                            controller: 'MilestoneModalCreateController',
                            size: 'md',
                            backdrop: false,
                            resolve: {
                                milestone: function() {
                                    return {};
                                },
                            },
                        });
                    }

                    function edit(milestone) {
                        return $modal.open({
                            template: require('../view/milestone-modal-create.html'),
                            controller: 'MilestoneModalCreateController',
                            size: 'md',
                            backdrop: false,
                            resolve: {
                                milestone: function() {
                                    return milestone;
                                },
                            },
                        });
                    }
                }];
